import React from 'react';

interface Props {
  totalPrompts: number;
  publicPrompts: number;
  privatePrompts: number;
  totalUsers: number;
  activeCategories: number;

  recentUsers: {
    uid: string;
    name: string;
    email: string;
    role?: string;
  }[];

  recentPrompts: {
    id: string;
    content: string;
    categoryName?: string;
    author?: string;
  }[];
}

const DashboardSection: React.FC<Props> = ({
  totalPrompts,
  publicPrompts,
  privatePrompts,
  totalUsers,
  activeCategories,
  recentUsers,
  recentPrompts,
}) => {
  return (
    <>
      <div className="mb-10">
        <h1 className="text-4xl font-bold">
          Dashboard
        </h1>

        <p className="text-slate-400 mt-2">
          Visão geral da Nexora.
        </p>
      </div>

      {/* CARDS */}

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-5 gap-4">

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5">
          <p className="text-slate-400 text-sm">
            Usuários
          </p>

          <h2 className="text-3xl font-bold mt-2">
            {totalUsers}
          </h2>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5">
          <p className="text-slate-400 text-sm">
            Total de Prompts
          </p>

          <h2 className="text-3xl font-bold mt-2">
            {totalPrompts}
          </h2>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5">
          <p className="text-slate-400 text-sm">
            Públicos
          </p>

          <h2 className="text-3xl font-bold mt-2">
            {publicPrompts}
          </h2>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5">
          <p className="text-slate-400 text-sm">
            Privados
          </p>

          <h2 className="text-3xl font-bold mt-2">
            {privatePrompts}
          </h2>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-5">
          <p className="text-slate-400 text-sm">
            Categorias
          </p>

          <h2 className="text-3xl font-bold mt-2">
            {activeCategories}
          </h2>
        </div>

      </div>

      {/* TABELAS */}

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 mt-8">

        {/* Últimos Usuários */}

        <div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden">

          <div className="p-5 border-b border-slate-800">

            <h2 className="text-xl font-semibold">
              Últimos Usuários
            </h2>

          </div>

          <table className="w-full">

            <thead className="bg-slate-950">

              <tr>

                <th className="text-left p-4">
                  Nome
                </th>

                <th className="text-left p-4">
                  Email
                </th>

                <th className="text-left p-4">
                  Cargo
                </th>

              </tr>

            </thead>

            <tbody>

              {recentUsers.map(user => (

                <tr
                  key={user.uid}
                  className="border-t border-slate-800"
                >

                  <td className="p-4">
                    {user.name}
                  </td>

                  <td className="p-4">
                    {user.email}
                  </td>

                  <td className="p-4">
                    {user.role || 'user'}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        {/* Últimos Prompts */}

        <div className="bg-slate-900 border border-slate-800 rounded-2xl overflow-hidden">

          <div className="p-5 border-b border-slate-800">

            <h2 className="text-xl font-semibold">
              Últimos Prompts
            </h2>

          </div>

          <table className="w-full">

            <thead className="bg-slate-950">

              <tr>

                <th className="text-left p-4">
                  Prompt
                </th>

                <th className="text-left p-4">
                  Categoria
                </th>

                <th className="text-left p-4">
                  Autor
                </th>

              </tr>

            </thead>

            <tbody>

              {recentPrompts.map(prompt => (

                <tr
                  key={prompt.id}
                  className="border-t border-slate-800"
                >

                  <td className="p-4 max-w-[220px] truncate">
                    {prompt.content}
                  </td>

                  <td className="p-4">
                    {prompt.categoryName}
                  </td>

                  <td className="p-4">
                    {prompt.author || 'Desconhecido'}
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>
    </>
  );
};

export default DashboardSection;